import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputUnderlineProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  isEditing?: boolean;
}

const InputUnderline = React.forwardRef<HTMLInputElement, InputUnderlineProps>(
  ({ className, type, isEditing = false, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full border-0 border-b-2 border-black bg-transparent px-0 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-black disabled:cursor-not-allowed disabled:opacity-50 rounded-0",
          isEditing ? "rounded-none" : "rounded-lg",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
InputUnderline.displayName = "InputUnderline";

export { InputUnderline };
